import { render, staticRenderFns } from "./FormSectionTitle.vue?vue&type=template&id=07d78e54&scoped=true&"
import script from "./FormSectionTitle.vue?vue&type=script&lang=js&"
export * from "./FormSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d78e54",
  null
  
)

export default component.exports